<div>
  @if (paragraph.display_text) {
    <quill-editor [ngModel]="paragraph.display_text" [readOnly]="true" class="readonly"
      [modules]="{clipboard:{matchVisual:false}}" contenteditable="false" placeholder="">
    </quill-editor>
  }
  @if (!paragraph.display_text) {
    <quill-editor [ngModel]="place_holder" [readOnly]="true" class="readonly"
      contenteditable="false" placeholder="Enter custom text">
    </quill-editor>
  }
</div>
